import React, { Component, Fragment } from 'react'
import styled from 'styled-components';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

// Custom components
import FormCheckboxField from 'containers/CompanyContainer/Forms/Components/FormCheckboxField';
import CompanyPageButton from 'containers/CompanyContainer/CompanyPageButton';
import CompanyInterfaceForm, {
    ComponentWrapper,
    FormWrapper,
    FormRowWrapper,
    FormColumnWrapper,
    TopContainer
} from 'containers/CompanyContainer/CompanyInterfaceForm';
import LoaderWrapper from 'containers/CompanyContainer/LoaderWrapper';

// Constants
import { constants } from 'constants/index';

class AdminSetupForm extends CompanyInterfaceForm {
    state = {
        firstName: '',
        lastName: '',
        isProvider: false,
        profilePhotoURL: null,
        phone: '1',
        providerLiabilityPolicyNumber: '',
        providerLiabilityPolicyHolder: '',
        coverPhotoURL: null,
        biography: '',
        designation: '',
        email: '',
        expertise: '',
        isTaxExempt: false,
        licenseNumber: '',
        taxNumber: '',
        certifications: [],
        formValidationErrors: {}
    }

    componentDidMount () {
        const { getClientData, authData } = this.props;
        const { email, uid } = authData;
        getClientData(uid);
        this.setState({ email });
        this.hydrateStateWithLocalStorage();

        window.addEventListener(
            "beforeunload",
            this.saveStateToLocalStorage.bind(this)
        );
    }

    handleTextChange = (event) => {
        const { name, value } = event.target;
        if(name === 'phone'){
            // Remove all special characters from the masking
            let normalizedInput = ('' + value).replace(/\D/g, '');
            // Check that the input is at max 11 characters long, which is the expected length with the area and the country code
            normalizedInput.length <= 11 && this.setState({ [name] : normalizedInput});
        } else {
            this.setState({ [name] : value});
        }
    }

    formatDataForDB = (event) => {
        const { isProvider } = this.state;
        event && event.preventDefault();
        let formattedUserData = this.formatUserDataForDB();
        let roleData = {
            roles: {
                accountAdmin: true,
                staffAdmin: true,
                provider: isProvider
            }
        }
        formattedUserData = {
            ...formattedUserData,
            provider: true,
            ...roleData
        }
        let formattedProviderData = this.formatProviderDataForDB();
        formattedProviderData = { ...formattedProviderData, ...roleData };
        this.props.dispatchAdminFormData({
            formattedUserData,
            formattedProviderData
        });

        window.removeEventListener(
            "beforeunload",
            this.saveStateToLocalStorage.bind(this)
        );
        this.props.history.push('/company/companyEditor');
    }

    getFormFields = () => {
        const { isProvider } = this.state;
        return(
            <React.Fragment>
                <FormRowWrapper>
                    <FormColumnWrapper>
                        {this.getPersonalFields()}
                        <FormCheckboxField
                            label="Will you also be providing health services to clients?"
                            name="isProvider"
                            onChange={this.handleChange}
                            value = { isProvider }
                            containerProps = {{
                                background: 'none',
                                border: 'none'
                            }}
                        />
                        {isProvider && this.getProviderLegalFields()}
                        {isProvider && this.getCoverPhotoField({subTitle: false})}
                    </FormColumnWrapper>
                    <FormColumnWrapper>
                        {isProvider && this.getProviderInformationFields()}
                        {isProvider && this.getProviderProfessionalFields()}
                    </FormColumnWrapper>
                </FormRowWrapper>
            </React.Fragment>
        )
    }

    checkValidation = ({event, type, parent, index}) => {
        const { name, value } = event.target;
        const errorMessage = this.validateInput({
            type,
            value: event.target.value
        });
        let formValidationErrors = {...this.state.formValidationErrors};

        if(parent){
            formValidationErrors[parent][index][name] = errorMessage;

        } else {
            formValidationErrors[name] = errorMessage;
        }
        this.setState({formValidationErrors})
    }

    render () {
        const { authData, userData, waitingOnCompanySetupFormData } = this.props;
        (userData.providerCompany) && this.props.history.push('/company/dashboard');
        let loader;
        waitingOnCompanySetupFormData
            ? loader = <LoaderWrapper/>
            : loader = null;

        return (
            <ComponentWrapper>
                { loader }
                <FormWrapper onSubmit={this.formatDataForDB}>
                    <TopContainer>
                        <CompanyPageButton
                            test-label="saveButton"
                            type={'dark'}
                            size={'small'}
                            children={'Submit and continue'}
                        />
                    </TopContainer>
                    {this.getFormFields()}
                </FormWrapper>
            </ComponentWrapper>
        );
    }
}

const mapStateToProps = ({auth, company, router, client}) => ({
    companyInfo: company.companyInfo,
    userData: client.clientData,
    services: company.services,
    authData: auth.authData,
    location: router.location,
    waitingOnCompanySetupFormData: company.waitingOnCompanySetupFormData
});

export default connect(mapStateToProps,actions)(AdminSetupForm);


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/AdminSetupForm.jsx